const $ = require('jquery');
import slick from 'slick-carousel';

$(document).ready(function() {

    $("#testimonials-slider").slick({
        infinite: true,
        dots: false,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                }
            }
        ]
    });

});
